import { CoreState } from '../modules';

export const orders = (state: CoreState) => state.ordersCache.orders;
